module.exports = __webpack_public_path__ + "static/media/Follower_Purple.9fbf473f.png";